import fbConfig from '../../config/fbConfig'
import moment from 'moment'
import 'moment/locale/es'
import emailjs, { init } from "emailjs-com";

// Inicializamos nuestro user ID
init("user_tPoAH5Dox4FCzgEsYZ1AG");

// Obtenemos todos los tipos de anuncios disponibles
export const getAllAds = () => {
    return async (dispatch, getState) => {

        let arrayAds = []
        fbConfig.firestore().collection('ads').onSnapshot(snap => {
            for (const doc of snap.docs) {

                arrayAds.push({
                    ...doc.data(),
                    id: doc.id
                })

                if( arrayAds.length === snap.docs.length ) {
                    dispatch({ type: 'GET_ADS', ads: arrayAds })
                }
            }
        })

    }   
}

export const createPreferences = ({genre, profession, adblocker, birthday, type_ads, phone}) => {
    return async (dispatch, getState) => {
        
        const user = await fbConfig.auth().currentUser;

        if(user && user.uid) {

            // Damos al usuario 10 puntos por registrarse
            await fbConfig.firestore().collection('preferences').add({
                user_id: user.uid,
                genre: genre || null,
                profession: profession || null,
                adblocker: adblocker || null,
                birthday: fbConfig.firestore.Timestamp.fromDate(new Date(birthday)) || null,
                phone,
                id_ads: type_ads || [],
                income: null,
                created_at: fbConfig.firestore.FieldValue.serverTimestamp()
            });

            await fbConfig.firestore().collection('users').doc(user.uid).set({
                shield_points: [{
                    points: 10,
                    created_at: new Date()
                }]
            }, {merge: true})

            await dispatch({ type: 'CREATE_PREFERENCES_USER', uid: user.uid })

        }

    }
}

// Funcion para calcular las dos ultimas semanas
export const getTwoLastWeeks = () => {
    return async (dispatch, getState) => {

        const user = await fbConfig.auth().currentUser

        if(user && user.uid) {

            const dataAux = [];

            const data = await fbConfig.firestore().collection('users').doc(user.uid).get()

            // Obtenemos la informacion de las dos ultimas semanas
            const newArrayPoint = data.data().shield_points.slice(data.data().shield_points.length - 12);

            for (const doc of newArrayPoint) {

                let date = moment(new Date(doc.created_at.seconds * 1000)).format("Do MMM")
                dataAux.push({
                    name: date,
                    points: doc.points
                })

            }

            dispatch({ type: 'GET_SHIELD_POINTS', data_points: dataAux })
        }
    }
    
}

export const getDataProfile = () => {
    return async (dispatch, getState) => {

        const user = await fbConfig.auth().currentUser;

        if(user && user.uid) {

            const response = await fbConfig.firestore().collection('users').doc(user.uid).get()
            dispatch({ type: 'GET_DATA_PROFILE', data: response.data() })

        }

    }
}

// Funcion para obtener los datos de preferencias del usuario
export const getDataPreferencesFromUser = () => {
    return async (dispatch, getState) => {

        const user = await fbConfig.auth().currentUser;
        let result = {}

        if(user && user.uid) {

            // Obtenemos las preferencias
            const dataPref = await fbConfig.firestore().collection('preferences').where('user_id', '==', user.uid).get();

            // Obtenemos los anuncios
            if(dataPref.docs.length > 0) {
                const { id_ads } = dataPref.docs[0].data();
                const dataAds = id_ads.map(async (ia) => {
                    const response = await fbConfig.firestore().collection('ads').doc(ia).get()
                    return {...response.data(), id: response.id}
                })

                const responseAds = await Promise.all(dataAds);

                const { adblocker, birthday, genre, profession, phone} = dataPref.docs[0].data()
                result = {
                    adblocker,
                    birthday,
                    genre,
                    phone: phone || null,
                    profession,
                    ads: [...responseAds],
                    id: dataPref.docs[0].id,
                    income: dataPref.docs[0].data().income || null
                }
                
                dispatch({ type: 'GET_DATA_PREFERENCES', result })
            }else {
                dispatch({ type: 'GET_DATA_PREFERENCES_FAILED', err: 'This user not exists' })
            }
        }

    }
}

// Funcion para obtener las preferencias de privacidad
export const getPreferencesPrivacity = () => {
    return async (dispatch, getState) => {

        const user = await fbConfig.auth().currentUser;
        let arrayResponse = []

        if(user && user.uid) {

            const resultPref = await fbConfig.firestore().collection('preferences_privacity').get();
            
            for (const doc of resultPref.docs) {
                arrayResponse.push({
                    ...doc.data(),
                    id: doc.id
                })
            }

            dispatch({ type: 'GET_PREFERENCES_PRIVACITY', dataPrivacity: arrayResponse })

        }

    }
}

// Funcion para actualizar las preferencias de un usuario
export const updatePreferencesOfUser = async ({adblocker, birthday, genre, id, income, profession, type_ads, prefDefault, phone, email, password, image_profile, provider }) => {

    try {
        const user = await fbConfig.auth().currentUser;

        if(user && user.uid) {

            if(image_profile && image_profile.name) {
                // Subimos las imagenes al storage de firebase y obtenemos su url
                const url = await uploadImageProfile({id: user.uid, image_profile});
                console.log(url)

                // Actualizamos el email y la contraseña
                if(provider === 'password') {
                    await user.updateEmail(email);
                    if(password && password.length > 0) {
                        await user.updatePassword(password)
                    }

                    // // Guardamos los datos del usuario en firestore
                    await fbConfig.firestore().collection('users').doc(user.uid).set({
                        email,
                        image_profile: url
                    }, {merge: true})
                }
                

                await fbConfig.firestore().collection('preferences').doc(id).set({
                    adblocker,
                    birthday,
                    genre,
                    phone,
                    income,
                    profession,
                    id_ads: type_ads || prefDefault
                }, { merge: true })

                return {
                    status: true
                }
            } else {

                // Actualizamos el email y la contraseña
                if(provider === 'password') {
                    await user.updateEmail(email);
                    if(password && password.length > 0) {
                        await user.updatePassword(password)
                    }

                    // // Guardamos los datos del usuario en firestore
                    await fbConfig.firestore().collection('users').doc(user.uid).set({
                        email
                    }, {merge: true})
                }

                

                await fbConfig.firestore().collection('preferences').doc(id).set({
                    adblocker,
                    birthday,
                    genre,
                    phone,
                    income,
                    profession,
                    id_ads: type_ads || prefDefault
                }, { merge: true })

                return {
                    status: true
                }

            }
            

        }
    } catch (error) {
        console.error(error);
        return {error}
    }

}

// Funcion para actualizar nuestras prefrerencias de privacidad
export const updatePreferencesPrivacityOfUser = prefsPrivacity => {
    return async (dispatch, getState) => {
        const user = fbConfig.auth().currentUser;
        if(user && user.uid) {
            
            await fbConfig.firestore().collection('users').doc(user.uid).set({
                preferences_privacity: prefsPrivacity
            }, {merge: true})

            await dispatch({ type: 'UPDATE_PREFERENCES_PRIVACITY_USER' });

        }
    }
}

// Funcion para cambiar nuestro modo 
export const changeModeUser = mode => {
    return async(dispatch, getState) => {
        const user = fbConfig.auth().currentUser;
        if(user && user.uid) {
            await fbConfig.firestore().collection('users').doc(user.uid).set({
                mode
            }, { merge: true });
            await dispatch({ type: 'UPDATE__MODE_USER' })
        }else {
            window.location = `${window.location.origin}/signin`
        }
    }
}

// Support con Shield por parte del cliente
export const sendMessageToSupport = async (data) => {
    try {

        const user = await fbConfig.auth().currentUser;
        if(user && user.email) {
            emailjs.send("service_vr74p5a", "template_405tvh7", {...data, user_email: user.email});
            return {
                status: true
            }
        }else {
            return {
                error: {
                    message: 'This user not exists'
                }
            }
        }
        
    } catch (error) {
        console.error(error);
        return {error}
    }
}

// Funcion para subir una imagen al storage
async function uploadImageProfile(user) {
    const path = `users/${user.id}/${user.image_profile.name}`;
    const ref = fbConfig.storage().ref(path);
    await ref.put(user.image_profile);
    const getUrlImage = await fbConfig.storage().ref(path).getDownloadURL()
    return getUrlImage;
}
